export const yettelLight = {
  placeholder: (defaultStyles: any) => ({
    ...defaultStyles,
    color: '#929B9E',
  }),
  control: (base: any, state: any) => ({
    ...base,
    border: '2px solid #E5E9EC',
    boxShadow: state.isFocused && '0px 0px 1px 2px #002340',
    '&:hover': {
      border: '2px solid #E5E9EC',
      boxShadow: state.isFocused && '0px 0px 1px 2px #002340',
    },
  }),
  option: (provided: any, state: any) => ({
    ...provided,
    fontFamily: state.isSelected ? 'YettelBold' : 'Yettel',
    color: state.isSelected && '#002340',
    backgroundColor: 'transparent',
    '&:hover': {
      color: 'black',
      fontFamily: state.isSelected && 'YettelBold',
      backgroundColor: '#F3FCFF',
    },
  }),
};

export const yettelNoBorder = {
  placeholder: (defaultStyles: any) => ({
    ...defaultStyles,
    color: '#929B9E',
  }),
  control: (base: any, state: any) => ({
    ...base,
    border: 'none',
    'background-color': 'white',
    boxShadow: state.isFocused && 'none',
  }),
  indicatorSeparator: () => ({
    border: 'none',
    'background-color': 'transparent',
    boxShadow: 'none',
  }),
  option: (provided: any, state: any) => ({
    ...provided,
    fontFamily: state.isSelected ? 'YettelBold' : 'Yettel',
    color: state.isSelected && '#002340',
    backgroundColor: 'transparent',
    '&:hover': {
      color: 'black',
      fontFamily: state.isSelected && 'YettelBold',
      backgroundColor: '#F3FCFF',
    },
  }),
};
export const yettelDark = {
  control: (provided: any) => ({
    ...provided,
    background: '#002340',
    border: 0,
    boxShadow: 'none',
  }),
  singleValue: (provided: any) => ({
    ...provided,
    width: '400px',
    color: '#fff',
  }),
  dropdownIndicator: (provided: any, state: any) => ({
    ...provided,
    color: '#fff',
    transform: state.selectProps.menuIsOpen && 'rotate(180deg)',
    '&:hover': {
      color: '#d3d3d3',
    },
  }),
  option: (provided: any) => ({
    ...provided,
    '&:hover': {
      backgroundColor: '#F3FCFF',
    },
  }),
};
